<template>
    <div class="page-wework-combine">
        <content-title></content-title>
        <router-view></router-view>
    </div>
</template>

<script>
import ContentTitle from '../../content-title';

export default {
    components: {
        ContentTitle
    },

    data() {
        return {};
    },

    created() {}
};
</script>
